import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from './authContext';

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth ist nur innerhalb von AuthProvider verwendbar.');
  }
  return context;
}
